import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactElement } from "react";
import Select, {
  ClearIndicatorProps,
  DropdownIndicatorProps,
  MenuListProps,
  components,
} from "react-select";
import { StateManagerProps } from "react-select/dist/declarations/src/useStateManager";
import { VariableSizeList } from "react-window";

interface ReactSelectProps extends StateManagerProps {
  icon?: ReactElement;
}

const ClearIndicator = (props: ClearIndicatorProps) => {
  const {
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div {...restInnerProps} ref={ref} className="me-2">
      <div className="text-primary fs-9">limpar</div>
    </div>
  );
};

const DropdownIndicator = (props: DropdownIndicatorProps) => {
  return (
    <components.DropdownIndicator {...props}>
      <FontAwesomeIcon icon={faAngleDown} className="fs-9 text-body" />
    </components.DropdownIndicator>
  );
};

export const MenuList = ({ children, ...rest }: MenuListProps) => {
  const getItemSize = (index: number) => {
    const str = (rest.options[index] as any)?.label;

    if (str.length > 45) return 70;

    if (str.length > 39) return 50;

    return 30;
  };

  return (
    <VariableSizeList
      height={
        (children as any)?.length > 5 ? 175 : (children as any)?.length * 35
      }
      itemCount={(children as any)?.length ?? 0}
      itemSize={getItemSize}
      width="100%"
    >
      {({ index, style }) => (
        <div style={style}>{(children as any)?.[index]}</div>
      )}
    </VariableSizeList>
  );
};

const ReactSelect = ({ icon, ...rest }: ReactSelectProps) => {
  return (
    <div className="react-select-container">
      <Select
        closeMenuOnSelect={true}
        components={{ ClearIndicator, DropdownIndicator, MenuList }}
        classNamePrefix="react-select"
        classNames={{
          control: () => (icon ? "ps-5" : ""),
          placeholder: () => (icon ? "ps-2" : ""),
        }}
        {...rest}
      />
      {icon}
    </div>
  );
};

export default ReactSelect;
